module.exports = __webpack_public_path__ + "images/images/Goober-open-jump-cutout-d3725485efc0742b42a401ee61d069a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Goober-open-jump-cutout.png
// module id = 2522
// module chunks = 2